import { render, staticRenderFns } from "./ExpandingButton.vue?vue&type=template&id=6f1e355a"
import script from "./ExpandingButton.vue?vue&type=script&lang=js"
export * from "./ExpandingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f1e355a')) {
      api.createRecord('6f1e355a', component.options)
    } else {
      api.reload('6f1e355a', component.options)
    }
    module.hot.accept("./ExpandingButton.vue?vue&type=template&id=6f1e355a", function () {
      api.rerender('6f1e355a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpandingButton.vue"
export default component.exports